module.exports = __webpack_public_path__ + "b9625119ce4300f0ef890a8f3234c773.ttf";